var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSticker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 4.8 4.8 0 24 0C43.2 0 48 4.8 48 24C48 43.2 43.2 48 24 48C4.8 48 0 43.2 0 24Z",
    fill: "#8282FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8952 25.2892C38.8652 25.5742 38.8202 25.8442 38.7452 26.1142C37.1852 24.7942 35.1602 23.9992 32.9552 23.9992C27.9902 23.9992 23.9552 28.0342 23.9552 32.9992C23.9552 35.2042 24.7502 37.2292 26.0702 38.7892C25.8002 38.8642 25.5302 38.9092 25.2452 38.9392C23.9702 39.0592 22.6652 38.9992 21.3152 38.7742C15.1502 37.7242 10.1852 32.7292 9.16523 26.5492C7.47023 16.2742 16.2302 7.51417 26.5052 9.20917C32.6852 10.2292 37.6802 15.1942 38.7302 21.3592C38.9552 22.7092 39.0152 24.0142 38.8952 25.2892Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7451 26.115C38.5351 26.85 38.1451 27.51 37.5901 28.065L28.0201 37.635C27.4651 38.19 26.8051 38.58 26.0701 38.79C24.7501 37.23 23.9551 35.205 23.9551 33C23.9551 28.035 27.9901 24 32.9551 24C35.1601 24 37.1851 24.795 38.7451 26.115Z",
    fill: "#111827"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSticker);
export default __webpack_public_path__ + "static/media/sticker.013b7171be6ccba25324898222239a3e.svg";
export { ForwardRef as ReactComponent };